import { render, staticRenderFns } from "./descontos.vue?vue&type=template&id=4ca6b064"
import script from "./descontos.vue?vue&type=script&lang=js"
export * from "./descontos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports